
<h2 style="background-color: #326395 !important;color: white;text-align:center;">
  Confirm Beneficiary Detail
  <button mat-button class="close-button" [mat-dialog-close]="true" style="float: right;">
    <mat-icon>close</mat-icon>
  </button>

</h2>
<table class="table table-hover text-center  table-bordered">
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Service Name
    </td>
    <td style="white-space: nowrap;">
      {{beneficiary_serviceName}}
    </td>
  </tr>

  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Country Name
    </td>
    <td style="white-space: nowrap;">
      {{countrytxt}}<br />

    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Bank Name
    </td>

    <td style="white-space: nowrap;">
      {{channel}}<br />

    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Bank Account No.
    </td>

    <td style="white-space: nowrap;">
      {{beneficiary_account_no}}<br />

    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Mobile Number
    </td>
    <td style="white-space: nowrap;">
      {{beneficiary_phone}}
    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      First Name
    </td>

    <td style="white-space: nowrap;">
      {{beneficiary_fname}}
    </td>
  </tr>

  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Last Name
    </td>
    <td style="white-space: nowrap;">
      {{beneficiary_lname}}<br />

    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      E-mail
    </td>

    <td style="white-space: nowrap;">
      {{beneficiary_email}}<br />

    </td>
  </tr>
  <!--<tr class="col-lg-12 col-sm-12">
    <td class="col">
      Beneficiary Id
    </td>
    <td style="white-space: nowrap;">
      {{beneficiary_id}}
    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Beneficiary Id Number
    </td>

    <td style="white-space: nowrap;">
      {{beneficiary_id_number}}
    </td>
  </tr>

  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Beneficiary Nationality
    </td>
    <td style="white-space: nowrap;">
      {{beneficiary_nationality}}
    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Beneficiary Relationship
    </td>

    <td style="white-space: nowrap;">
      {{beneficiary_relationship}}
    </td>
  </tr>
  <tr class="col-lg-12 col-sm-12">
    <td class="col">
      Beneficiary Type
    </td>

    <td style="white-space: nowrap;">
      {{beneficiary_type}}
    </td>
  </tr>-->


</table>

<div style="text-align:center;">


  <!--<a class="btn btn-primary" [routerLink]="['/EditMobileMoneBeneficiary/SMA']" [queryParams]="{ 'editId': editId}" [skipLocationChange]="true" [mat-dialog-close]="false">  EDIT    </a>-->
  <button type="button" class="btn btn-primary" (click)="BeneficiaryInfoEDITbyId()" [mat-dialog-close]="false">EDIT</button>
  &nbsp; &nbsp;
  <button type="button" class="btn btn-info" (click)="BeneficiaryInfoDELETEbyId()" [mat-dialog-close]="false">DELETE</button>
  &nbsp; &nbsp;

  <button type="button" class="btn btn-danger" [mat-dialog-close]="false">
    Close
  </button>
</div>

